import * as S from './styled';
import { LayoutType } from '../../types'
import { ReactComponent as CheckIcon } from '../../assets/check-icon.svg';

type ItemProps = {
	type: string,
	layout: LayoutType,
	onLayoutChange: (value: LayoutType) => void,
	isValid: boolean
};

const LayoutPickerItem = ({
	type,
	layout,
	isValid,
	onLayoutChange
}: ItemProps) => {
	return (
		<S.Container>
			<S.Radio type="radio" checked={layout === type} value={type} onChange={(e) => onLayoutChange(e.target.value as LayoutType)} />
			<S.ControlWrap valid={isValid}>
				<S.Check>
					<CheckIcon />
				</S.Check>
				<S.ControlLabel>{type}</S.ControlLabel>
			</S.ControlWrap>
		</S.Container>
	)
}

export default LayoutPickerItem;
